<template>
    <div id="CommentSettings">
        <div class="card">
            <div class="mode-card">
                <div class="title">Ticket
                    <a-switch
                        class="md-warning ml-3"
                        checked-children="✔"
                        un-checked-children="✖"
                        v-model="ticketMode"
                        @change="handleTicketModeChange"
                    />
                </div>
                <div class="subtitle">{{ $t("instagram.commentSettingsTicket") }}</div>
            </div>
        </div>
        <div class="card">
            <div class="mode-card">
                <div class="title">{{ $t("chatbotv2.chatbot") }}
                    <a-switch
                        class="md-warning ml-3"
                        checked-children="✔"
                        un-checked-children="✖"
                        v-model="chatbotMode"
                        @change="handleChatbotModeChange"
                    />
                </div>
                <div class="subtitle">{{ $t("instagram.commentSettingsChatbot") }}</div>
                <div v-if="chatbotMode">
                    <a-select
                        v-model="channel.commentForward.story"
                        :defaultValue="null"
                        :notFoundContent="$t('search.integration.forwardLiveAgents')"
                        style="width: 100%; margin-top: 10px"
                    >
                        <a-select-option
                            :key="story._id"
                            v-for="story in stories"
                            :value="story._id"
                        >
                            {{ story.title }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "ChannelForwardSetting",
    props: {
        channel: {
            type: Object,
            default: () => ({}),
            required: true,
        },
    },
    data() {
        this.channel.commentForward = this.channel.commentForward || {};
        return {
            ticketMode: this.channel.commentForward.mode === "ticket",
            chatbotMode: this.channel.commentForward.mode === "chatbot",
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
        }),
    },
    methods: {
        ...mapActions({
            listStories: "CB/listStories",
        }),
        checkHaveChatbotStory(id) {
            return this.stories.find((story) => story._id === id);
        },
        handleTicketModeChange(value) {
            this.ticketMode = value;
            if (!value) {
                this.chatbotMode = true;
            } else {
                this.chatbotMode = false;
            }
            this.channel.commentForward.mode = value ? "ticket" : "chatbot";
            this.channel.commentForward.story = null;
        },
        handleChatbotModeChange(value) {
            this.chatbotMode = value;
            if (!value) {
                this.ticketMode = true;
            } else {
                this.ticketMode = false;
            }
            this.channel.commentForward.mode = value ? "chatbot" : "ticket";
        },
    },
    mounted() {
        this.listStories();
    }
};
</script>

<style lang="scss" scoped>
#CommentSettings {
    margin-top: 20px;

    .card {
        margin-bottom: 20px;
    }

    .mode-card {
        width: 100%;
        padding: 20px;
        border-radius: 5px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
        background-color: #fff;

        .title {
            font-size: 18px;
            font-weight: 700;
            color: var(--color-text-strong-default);
            display: flex;
            justify-content: space-between;
            padding-bottom: 10px;
        }

        .subtitle {
            font-size: 14px;
            color: var(--color-text-strong-default);
        }
    }
}
</style>
